export default __webpack_public_path__ + "img/cfCNIURU.b0100901.svg";